const moutations = {
  addOrdinarySearchData (state, data) {
    state.ordinarySearchData = data
  },
  isShow (state) {
    state.isLogin = !state.isLogin
  }
}

export default moutations



// WEBPACK FOOTER //
// ./src/store/mutations.js